import {Component, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {NgClass} from '@angular/common';
import {SignatureComponent} from '../../../../../shared/components/signature/signature.component';
import {WizardType} from '../../wizard-type.enum';
import {VehicleBrand} from '../../../../../domain/core/vehicle-brand.model';
import {ActivitySpinnerComponent} from '../../../../../shared/components/activity-spinner/activity-spinner.component';
import {CustomerWizardResponse} from '../../../../../domain/data/customer-wizard-response.data';

@Component({
  selector: 'app-wizard-action-buttons',
  imports: [
    SignatureComponent,
    NgClass,
    ActivitySpinnerComponent
  ],
  standalone: true,
  templateUrl: './wizard-action-buttons.component.html'
})
export class WizardActionButtonsComponent implements OnChanges {
  @ViewChild('sig')
  set sigSetter(ref: SignatureComponent | undefined) {
    this._sig = ref;
    this.applySignatureToCanvas();
  }
  get sig(): SignatureComponent | undefined {
    return this._sig;
  }
  @Input() customerWizardResponse: CustomerWizardResponse;
  @Input() showActionButtons = false;
  @Input() currentStep = 0;
  @Input() brand: VehicleBrand;
  @Input() wizardType: WizardType;
  @Input() existingSignature?: string | null;
  @Input() skipAllInProgress = false;

  private _sig?: SignatureComponent;

  @Output() nextStep = new EventEmitter<void>();
  @Output() previousStep = new EventEmitter<void>();
  @Output() accept = new EventEmitter<string>();
  @Output() skip = new EventEmitter<void>();

  protected readonly WizardType = WizardType;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.wizardType !== WizardType.DIGITAL_SIGNATURE) {
      return;
    }

    if (changes['currentStep'] || changes['existingSignature']) {
      this.applySignatureToCanvas();
    }
  }

  private applySignatureToCanvas() {
    if (this.wizardType !== WizardType.DIGITAL_SIGNATURE) return;
    if (!this.sig) return;
    if (this.existingSignature) {
      this.sig.loadFromDataURL(this.existingSignature);
    } else {
      this.sig.clearCanvas();
    }
  }
}
